import {BaseStorageUtils} from "./base-storage-utils";

export class SessionStorageUtils extends BaseStorageUtils {
  static injectables = [];

  constructor() {
    super();

    this.storage = window.sessionStorage;
  }
}
